import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'angular-main',
    templateUrl: 'app.component.html',
    styleUrls: ['style.scss', 'app.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {

    private language: string;
    private showFooter = true;

    constructor(translate: TranslateService,
                private cookieService: CookieService) {
        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang('en');

        this.language = this.cookieService.get('i18n');
        if (this.language != null && this.language != undefined && this.language.length > 0) {
            //  // the lang to use, if the lang isn't available, it will use the current loader to get them
            translate.use(this.language);
        }
    }

    ngOnInit() {
    }

    onNotification(event: string) {
        if (event === 'Result') {
            this.showFooter = false;
        }
        if (event === 'Test') {
            this.showFooter = true;
        }
    }

}
